export default "{\n\t\"installDependencies\": true,\n\t\"startCommand\": \"npm run start\"\n}\n"